import type {
  BodyMeasurementsItem,
  ClientConfiguration,
  ConfigurationSection,
  ConfigurationTracking,
  TrackerKey,
  TrackingItemBase,
  TrackingItemWithSchedule,
} from "../../../../../../types/clientConfig";
import { TRACKER_FILTER_KEYS } from "./configFilters";

/**
 * How a config list row reads a client's config (AthleteRow.tsx). msb-api's
 * config-filters.js `summarizeConfigForFilters` applies the same rules, and
 * configFilters.contract.test.ts checks both against the shared fixture.
 */

export function sectionChipClass(
  section: ConfigurationSection | undefined
): "coach" | "client" | "disabled" {
  if (!section || (section.mode === "hidden" && !section.clientOptIn))
    return "disabled";
  if (section.mode === "coach") return "coach";
  return "client";
}

export function isGoalsOrCycleSectionEnabled(
  section: ConfigurationSection | undefined
): boolean {
  if (!section) return false;
  return (
    section.mode === "coach" ||
    section.mode === "client" ||
    Boolean(section.clientOptIn)
  );
}

/**
 * Only known trackers: msb-api's effective config also carries a
 * `questionnaire` item (not a real tracker, on for every `default_push`
 * client), which has no icon or label here.
 */
export function enabledTrackingItemKeys(
  tracking: ConfigurationTracking | undefined
): TrackerKey[] {
  const items = tracking?.items as
    | Partial<
        Record<
          TrackerKey,
          TrackingItemBase | TrackingItemWithSchedule | BodyMeasurementsItem
        >
      >
    | undefined;
  if (!items) return [];
  return TRACKER_FILTER_KEYS.filter(
    (key) => items[key]?.coachRequired || items[key]?.clientEnabled
  );
}

export function templateDisplayLabel(config: ClientConfiguration): string {
  // Not linked to a template (standalone doc or migration preview): the
  // filter files these under "No template", so the row shows none either.
  if (!config.templateId || config.templateType === "migration") {
    return "—";
  }

  return (
    config.templateName ||
    (config.templateType ? `(${config.templateType})` : null) ||
    "—"
  );
}
